import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_stock_level_monitoring_template_hdr_RowClass } from '../../../dbschema/bl_inv_stock_level_monitoring_template_hdr.model';

export class StockLevelMonitoringTemplateHdrModel extends BaseContainerModel {
  bl_inv_stock_level_monitoring_template_hdr: bl_inv_stock_level_monitoring_template_hdr_RowClass = new bl_inv_stock_level_monitoring_template_hdr_RowClass();
}
